import { useCallback } from "react"
import { useDispatch, useSelector } from "react-redux"

import { storeApiLoading } from "actions"

const useApiLoading = () => {
  const dispatch = useDispatch()
  return {
    isApiLoading: useSelector((state) => state.api.isApiLoading),
    storeApiLoading: useCallback(
      (props) => dispatch(storeApiLoading(props)),
      [dispatch]
    ),
  }
}

export default useApiLoading
